import { commonRequest } from '@/utils/request'

/** 添加网络列表 */
export function getNetworkList(params: {
  orgId: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/Data/NetList',
    params,
  })
}
/** 获取区域位置树 */
export function getOrgPosTree(params: {
  orgId: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/Org/Tree',
    params,
  })
}
/** 获取网络设备树 */
export function getNetworkTree(params: {
  orgId: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/Data/NetDevs',
    params,
  })
}
/** 获取位置下网络 */
export function getPosNetworkList(params: {
  orgId: string
  posId: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/Org/PosNetList',
    params,
  })
}
/** 获取位置下网络下组 */
export function getPosNetworkGroupList(params: {
  netId: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/NetBleMeshGroup/List/'+params.netId,

  })
}
/** 获取网络下设备 */
export function getNetworkDevList(params: {
  orgId: string
  netId: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/Org/NetDevList',
    params,
  })
}
/** 获取网络下电表设备 */
export function getNetworkDevListByElectric(params: {
  orgId: string
  netId: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/Org/NetDevListByElectric',
    params,
  })
}
/** 获取网络信息 */
export function getNetBleMesh(netId:string) {
  return commonRequest({
    method: 'get',
    url: `/V1/NetBleMesh/${netId}`,
  })
}

export function getOrgAll() {
  return commonRequest({
    method: 'get',
    url: '/V1/Org/List',
  })
}
